import { useQuery } from "@tanstack/react-query";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import BinApiService from "src/api/BinApiService";
import { queryClient } from "src";
import { QueryTypes } from './shared';
import fakeBinDto from '../fakeData/fakeBinDto.json';

export const useGetPremierPlusBinDto = (binId: number, options: QueryTypes = {}) => {
    
    const getPremierPlusBinDtoQueryKey = ["getPremierPlusBinDto", binId];

    const getPremierPlusBinDtoQuery = useQuery<PremierPlusBinDTO>({
        queryKey: [getPremierPlusBinDtoQueryKey],
        queryFn: async (q) => {

            // return Promise.resolve(fakeBinDto as unknown as PremierPlusBinDTO);
            return await BinApiService.getPremierPlusBinDetailFromAzure(binId, 0, q.signal);
        },
        enabled: options.enabled && binId > 0,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    })

    return { getPremierPlusBinDtoQueryKey, getPremierPlusBinDtoQuery }
}